import React, { useEffect, useState } from 'react';
import { Box, Drawer, Button, IconButton, ListItemIcon, ListItemText, List, Alert, ListItemButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../lib/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import EditTagModal from '../outfits/EditTagModal';


const Filter = ({ setOpenFilter, openFilter, setPendingChange, moments, setMoments, setActiveFilters }) => {
  const [user] = useAuthState(auth)
  const [userMoments, setUserMoments] = useState(null)
  const [pendingTagChange, setPendingTagChange] = useState(null)

  const { t } = useTranslation();

  const handleDrawerClose = () => {
    setOpenFilter(false);
    clearFormFields()
  };

  const clearFormFields = () => {
    setMoments([])
    setPendingChange(true)
    setActiveFilters("")
    setOpenFilter(false)
  }

  const handleListItemClick = (event, index) => {
    setMoments(index);
    setPendingChange(true)
    setOpenFilter(false)
  };

  useEffect(() => {
    if (pendingTagChange === false) return
    const momentsCollectionRef = collection(db, 'users', user.uid, 'moments');

    getDocs(momentsCollectionRef).then((querySnapshot) => {
      const documents = querySnapshot.docs.map(doc => ({ ...doc.data() /** {name: string} */, id: doc.id }));
      setUserMoments(documents)
      setPendingTagChange(false)
    }).catch((err) => {
      console.log("error getting document", err)
    })
  }, [pendingTagChange])

  if (userMoments === null) {
    return (
      <Box sx={{ height: 680, padding: 3, fontStyle: 'italic' }}>
        <Alert variant="outlined" severity="info">
          {t('emptyOutfitList')}
        </Alert>
      </Box>
    )
  }

  return (
    <Box>
      <Drawer
        anchor="left"
        open={openFilter}
        onClose={handleDrawerClose}
      >
        <Box style={{ width: '300px', position: 'relative' }}>
          <IconButton onClick={handleDrawerClose} sx={{ position: 'absolute', top: 0, right: 0 }}>
            <CloseIcon />
          </IconButton>
          <Box sx={{ marginLeft: '1rem' }}>
            <h2>{t('filterBy.title')} Tags</h2>
          </Box>
          <Box>
            {userMoments.map((moment) => (
              <List component="nav" aria-label="main mailbox folders" key={moment.id} sx={{ display: 'flex' }}>
                <ListItemButton
                  selected={moments === moment}
                  onClick={(event) => handleListItemClick(event, moment)}
                >
                  <ListItemIcon>
                    <CheckroomIcon />
                  </ListItemIcon>
                  <ListItemText primary={moment.name} />
                </ListItemButton>
                <Box>
                  <EditTagModal moment={moment} userId={user.uid} setPendingTagChange={setPendingTagChange} />
                </Box>
                <Divider />
              </List>
            ))}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-around', marginTop: "3rem" }}>
            <Button variant="contained" color="secondary" onClick={clearFormFields}>{t('filterBy.clearFilters')}</Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Filter;